module.exports = "../dist/frontend/icons/ui/categoryLoan.svg?b42322ce339b5100a6bd2c2b4e16ff59";